/* Remood — Store Layer JS
   panier ajax · recherche prédictive · facettes · récemment consultés ·
   cookies · compte client */

(function () {
  'use strict';

  const routes = window.RemoodRoutes || {};
  const strings = window.RemoodStrings || {};
  const settings = window.RemoodSettings || {};

  function formatMoney(cents) {
    const fmt = settings.moneyFormat || '{{amount}} €';
    const amount = (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }

  function updateCartCounts(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
    document.querySelectorAll('[data-cart-count-label]').forEach((el) => {
      el.textContent = '(' + count + ')';
    });
  }

  /* ═══════════ Panier : tiroir + page ═══════════
     - tiroir : section statique « cart-drawer » re-rendue via ?sections=cart-drawer
     - page   : section [data-cart-page] re-rendue de la même façon (plus de reload)
     - a11y   : dialog modal, focus piégé, Échap, retour du focus au déclencheur,
                région aria-live pour les mises à jour
     - suggestion « Souvent choisi avec » : Section Rendering des recommandations
       (intent=complementary, repli related) injectée dans [data-cart-recs] */

  const drawerSection = document.getElementById('shopify-section-cart-drawer');
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), select:not([disabled]), summary, iframe, [tabindex]:not([tabindex="-1"])';
  let lastTrigger = null;
  let liveEl = null;
  let recsToken = 0;
  let cartBusy = false;

  function drawerEls() {
    return {
      drawer: document.querySelector('[data-cart-drawer]'),
      veil: document.querySelector('[data-cart-drawer-veil]')
    };
  }

  function isDrawerOpen() {
    const { drawer } = drawerEls();
    return !!(drawer && drawer.classList.contains('open'));
  }

  /* Région aria-live persistante (hors des zones re-rendues) */
  function announce(msg) {
    if (!msg) return;
    if (!liveEl) {
      liveEl = document.createElement('div');
      liveEl.className = 'visually-hidden';
      liveEl.setAttribute('role', 'status');
      liveEl.setAttribute('aria-live', 'polite');
      liveEl.setAttribute('aria-atomic', 'true');
      document.body.appendChild(liveEl);
    }
    liveEl.textContent = '';
    setTimeout(() => { liveEl.textContent = msg; }, 60);
  }

  function rememberTrigger(el) {
    const { drawer } = drawerEls();
    if (isDrawerOpen()) return;
    const cand = el || document.activeElement;
    if (cand && cand !== document.body && !(drawer && drawer.contains(cand))) lastTrigger = cand;
  }

  function openCartDrawer(trigger) {
    const { drawer, veil } = drawerEls();
    if (!drawer) return false;
    rememberTrigger(trigger);
    drawer.removeAttribute('inert');
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (veil) veil.classList.add('open');
    document.body.classList.add('has-drawer');
    drawer.focus({ preventScroll: true });
    ensureRecs(drawer);
    return true;
  }

  function closeCartDrawer() {
    const { drawer, veil } = drawerEls();
    if (!drawer || !drawer.classList.contains('open')) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    if (veil) veil.classList.remove('open');
    document.body.classList.remove('has-drawer');
    if (lastTrigger && document.contains(lastTrigger)) {
      try { lastTrigger.focus({ preventScroll: true }); } catch (e) { /* noop */ }
    }
    lastTrigger = null;
  }

  /* Ré-applique l'état « ouvert » sur l'aside fraîchement injecté (sans animation) */
  function applyDrawerState(wasOpen) {
    const { drawer, veil } = drawerEls();
    if (!drawer || !wasOpen) return;
    drawer.removeAttribute('inert');
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    if (veil) veil.classList.add('open');
  }

  function focusables(root) {
    return Array.from(root.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null || el === document.activeElement);
  }

  /* Les boutons de paiement express sont injectés via innerHTML : on rejoue leurs scripts */
  function reviveScripts(root) {
    root.querySelectorAll('[data-cart-express] script').forEach((old) => {
      const s = document.createElement('script');
      Array.from(old.attributes).forEach((a) => s.setAttribute(a.name, a.value));
      s.textContent = old.textContent;
      old.replaceWith(s);
    });
    try {
      const sh = window.Shopify;
      if (sh && sh.StorefrontExpressButtons && typeof sh.StorefrontExpressButtons.initialize === 'function') {
        sh.StorefrontExpressButtons.initialize();
      }
    } catch (e) { /* noop */ }
  }

  async function fetchSectionHTML(id) {
    const url = (routes.cart || '/cart') + '?sections=' + encodeURIComponent(id);
    // Pas d'en-tête Accept: application/json — Shopify renverrait alors le JSON du panier
    // (comme /cart.js) au lieu du rendu de la section.
    const res = await fetch(url, { cache: 'no-store' });
    const data = await res.json();
    return (data && data[id]) || null;
  }

  function parseSection(html) {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.querySelector('.shopify-section') || tmp;
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    return res.json();
  }

  /* Désactive les contrôles de ligne pendant une requête */
  function setBusy(scope, busy) {
    if (!scope) return;
    scope.classList.toggle('is-loading', busy);
    scope.setAttribute('aria-busy', busy ? 'true' : 'false');
    scope.querySelectorAll('[data-line] button, [data-line] input, [data-cart-checkout], [data-rec-add]').forEach((el) => {
      if (busy) {
        if (!el.disabled) { el.disabled = true; el.dataset.busyLock = '1'; }
      } else if (el.dataset.busyLock) {
        el.disabled = false;
        delete el.dataset.busyLock;
      }
    });
  }

  function focusKeyFor(el) {
    const line = el && el.closest('[data-line]');
    if (!line) return { fallback: true };
    let sel = null;
    if (el.matches('[data-qty-change]')) sel = '[data-qty-change="' + el.dataset.qtyChange + '"]';
    else if (el.matches('[data-qty-input]')) sel = '[data-qty-input]';
    else return { fallback: true };
    return { line: line.dataset.line, sel: sel };
  }

  function restoreFocus(root, key) {
    if (!root || !key) return;
    let el = key.line ? root.querySelector('[data-line="' + key.line + '"] ' + key.sel) : null;
    if (!el) {
      if (root.matches('[data-cart-drawer]')) el = root;
      else {
        el = root.querySelector('.cart-line-title') || root.querySelector('h1');
        if (el && !el.hasAttribute('href')) el.setAttribute('tabindex', '-1');
      }
    }
    if (el) el.focus({ preventScroll: true });
  }

  /* ── Suggestion « Souvent choisi avec » ── */
  async function loadRecs(root) {
    const box = root && root.querySelector('[data-cart-recs]');
    if (!box || !box.dataset.url) return;
    box.dataset.loaded = '1';
    const token = ++recsToken;
    const intents = ['complementary', 'related'];
    for (let i = 0; i < intents.length; i++) {
      try {
        const res = await fetch(box.dataset.url + '&intent=' + intents[i], { headers: { Accept: 'text/html' }, cache: 'no-store' });
        if (token !== recsToken) return;
        if (!res.ok) continue;
        const tmp = document.createElement('div');
        tmp.innerHTML = await res.text();
        const hit = tmp.querySelector('[data-cart-recs-result]');
        if (hit) {
          box.innerHTML = hit.innerHTML;
          box.hidden = false;
          return;
        }
      } catch (e) { /* on tente l'intent suivant */ }
    }
    if (token === recsToken) { box.innerHTML = ''; box.hidden = true; }
  }

  function ensureRecs(root) {
    const box = root && root.querySelector('[data-cart-recs]');
    if (box && !box.dataset.loaded) loadRecs(root);
  }

  /* ── Re-rendu ── */
  async function refreshCartDrawer(opts) {
    opts = opts || {};
    if (!drawerSection) return;
    const wasOpen = isDrawerOpen();
    try {
      const html = await fetchSectionHTML('cart-drawer');
      if (!html) return;
      const prev = opts.keepRecs ? drawerSection.querySelector('[data-cart-recs]') : null;
      const prevHTML = prev && !prev.hidden ? prev.innerHTML : '';
      const prevUrl = prev ? prev.dataset.url : '';
      drawerSection.innerHTML = parseSection(html).innerHTML;
      applyDrawerState(wasOpen);
      reviveScripts(drawerSection);
      const { drawer } = drawerEls();
      const box = drawer && drawer.querySelector('[data-cart-recs]');
      if (box && prevHTML && box.dataset.url === prevUrl) { box.innerHTML = prevHTML; box.hidden = false; }
      if (wasOpen) {
        ensureRecs(drawer);
        if (opts.focusKey) restoreFocus(drawer, opts.focusKey);
        if (!opts.silent) announce(drawer && drawer.dataset.liveMsg);
      }
    } catch (e) { /* réseau : on garde l'état courant */ }
  }

  async function refreshCartPage(opts) {
    opts = opts || {};
    const page = document.querySelector('[data-cart-page]');
    const wrap = page && page.closest('.shopify-section');
    if (!wrap) { window.location.reload(); return; }
    try {
      const html = await fetchSectionHTML(page.dataset.sectionId);
      if (!html) { window.location.reload(); return; }
      wrap.innerHTML = parseSection(html).innerHTML;
      wrap.querySelectorAll('.reveal-section, .reveal-item, .reveal-stagger').forEach((n) => n.classList.add('is-visible'));
      const next = wrap.querySelector('[data-cart-page]');
      reviveScripts(wrap);
      ensureRecs(next);
      document.dispatchEvent(new CustomEvent('cart:page:rendered'));
      if (opts.focusKey) restoreFocus(next, opts.focusKey);
      if (!opts.silent) announce(next && next.dataset.liveMsg);
    } catch (e) { window.location.reload(); }
  }

  function refreshScope(scope, opts) {
    return scope && scope.matches('[data-cart-page]') ? refreshCartPage(opts) : refreshCartDrawer(opts);
  }

  function currentScope(el) {
    return (el && el.closest('[data-cart-drawer], [data-cart-page]')) || document.querySelector('[data-cart-page]') || drawerEls().drawer;
  }

  async function changeLine(line, quantity, scope, focusKey) {
    if (cartBusy || !scope) return;
    cartBusy = true;
    setBusy(scope, true);
    const errMsg = scope.dataset.errorMsg;
    try {
      const res = await fetch((routes.cartChange || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      const cart = await res.json();
      if (!res.ok || cart.status) {
        announce(errMsg);
      } else {
        updateCartCounts(cart.item_count);
      }
      await refreshScope(scope, { keepRecs: quantity !== 0, focusKey: quantity === 0 ? { fallback: true } : focusKey, silent: !res.ok });
    } catch (e) {
      announce(errMsg);
    } finally {
      setBusy(scope, false);
      cartBusy = false;
    }
  }

  async function addSuggestion(btn) {
    if (cartBusy) return;
    const scope = currentScope(btn);
    const card = btn.closest('.cart-rec-card');
    cartBusy = true;
    btn.disabled = true;
    if (card) card.classList.add('is-loading');
    try {
      const res = await fetch((routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.recAdd, 10), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      const cart = await fetchCart();
      updateCartCounts(cart.item_count);
      await refreshScope(scope, { focusKey: { fallback: true } });
    } catch (e) {
      btn.disabled = false;
      if (card) card.classList.remove('is-loading');
      announce(scope && scope.dataset.errorMsg);
    } finally {
      cartBusy = false;
    }
  }

  document.addEventListener('click', (e) => {
    /* Ouvrir le tiroir depuis les icônes panier */
    const cartToggle = e.target.closest('.cart-toggle');
    if (cartToggle && settings.cartType === 'drawer' && drawerSection) {
      if (openCartDrawer(cartToggle)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-cart-drawer-close]') || e.target.closest('[data-cart-drawer-veil]')) {
      closeCartDrawer();
      return;
    }

    /* Suggestion complémentaire */
    const recBtn = e.target.closest('[data-rec-add]');
    if (recBtn) {
      addSuggestion(recBtn);
      return;
    }

    /* Quantités & suppression */
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      const lineEl = qtyBtn.closest('[data-line]');
      const input = lineEl && lineEl.querySelector('[data-qty-input]');
      if (!lineEl || !input) return;
      const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(qtyBtn.dataset.qtyChange, 10));
      input.value = next;
      changeLine(parseInt(lineEl.dataset.line, 10), next, currentScope(lineEl), focusKeyFor(qtyBtn));
      return;
    }
    const removeBtn = e.target.closest('[data-line-remove]');
    if (removeBtn) {
      const lineEl = removeBtn.closest('[data-line]');
      if (!lineEl) return;
      changeLine(parseInt(lineEl.dataset.line, 10), 0, currentScope(lineEl), { fallback: true });
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-qty-input]')) {
      const lineEl = e.target.closest('[data-line]');
      if (!lineEl) return;
      const qty = Math.max(0, parseInt(e.target.value, 10) || 0);
      changeLine(parseInt(lineEl.dataset.line, 10), qty, currentScope(lineEl), focusKeyFor(e.target));
    }
    if (e.target.matches('[data-cart-note]')) {
      fetch((routes.cartUpdate || '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: e.target.value })
      });
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closeSearchOverlay();
      return;
    }
    /* Focus piégé dans le tiroir ouvert */
    if (e.key === 'Tab' && isDrawerOpen()) {
      const { drawer } = drawerEls();
      const items = focusables(drawer);
      if (!items.length) { e.preventDefault(); drawer.focus(); return; }
      const first = items[0];
      const last = items[items.length - 1];
      const ae = document.activeElement;
      if (e.shiftKey && (ae === first || ae === drawer)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && ae === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Ouverture après ajout au panier (événement émis par remood.js & co) */
  document.addEventListener('remood:cart:added', async () => {
    if (settings.cartType === 'drawer' && drawerSection) {
      rememberTrigger();
      await refreshCartDrawer({ silent: true });
      openCartDrawer();
    }
  });

  /* Page panier : suggestion au chargement */
  const initialCartPage = document.querySelector('[data-cart-page]');
  if (initialCartPage) ensureRecs(initialCartPage);

  /* Page panier (mobile) : barre de paiement fixe tant que le vrai bouton est sous l'écran.
     Éléments relus à chaque appel : la section est re-rendue après chaque modification. */
  function syncCartSticky() {
    const bar = document.querySelector('[data-cart-sticky]');
    const real = document.querySelector('.cart-page-summary [data-cart-checkout]');
    if (!bar || !real) return;
    const show = real.getBoundingClientRect().top > window.innerHeight;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    const btn = bar.querySelector('button');
    if (btn) btn.tabIndex = show ? 0 : -1;
  }
  if (initialCartPage) {
    let stickyRaf = 0;
    const queueSticky = () => {
      if (stickyRaf) return;
      stickyRaf = requestAnimationFrame(() => { stickyRaf = 0; syncCartSticky(); });
    };
    window.addEventListener('scroll', queueSticky, { passive: true });
    window.addEventListener('resize', queueSticky);
    document.addEventListener('cart:page:rendered', queueSticky);
    syncCartSticky();
  }

  /* ═══════════ Recherche prédictive ═══════════ */

  const overlay = document.getElementById('search-overlay');
  const searchInput = document.getElementById('predictive-search-input');
  const resultsEl = document.getElementById('predictive-search-results');
  let searchTimer = null;
  let searchAbort = null;

  function openSearchOverlay() {
    if (!overlay) return;
    overlay.hidden = false;
    document.body.classList.add('has-drawer');
    searchInput && searchInput.focus();
  }
  function closeSearchOverlay() {
    if (!overlay || overlay.hidden) return;
    overlay.hidden = true;
    document.body.classList.remove('has-drawer');
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('.search-toggle')) {
      e.preventDefault();
      openSearchOverlay();
    }
    if (e.target.closest('.search-overlay-close')) closeSearchOverlay();
    if (overlay && e.target === overlay) closeSearchOverlay();
  });

  function esc(s) {
    const d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  function renderPredictive(data, terms) {
    if (!resultsEl) return;
    const r = (data && data.resources && data.resources.results) || {};
    const groups = [];

    if (r.products && r.products.length) {
      groups.push(
        '<div class="predictive-group"><h3>Produits</h3>' +
        r.products.map((p) =>
          '<a class="predictive-item" href="' + esc(p.url) + '">' +
          (p.featured_image && p.featured_image.url
            ? '<img src="' + esc(p.featured_image.url) + '&width=112" alt="" loading="lazy" width="56" height="56">'
            : '') +
          '<span class="predictive-item-title">' + esc(p.title) + '</span>' +
          '<span class="predictive-item-price">' + esc(p.price ? p.price + ' €' : '') + '</span>' +
          '</a>'
        ).join('') + '</div>'
      );
    }
    if (r.articles && r.articles.length) {
      groups.push(
        '<div class="predictive-group"><h3>Articles</h3>' +
        r.articles.map((a) =>
          '<a class="predictive-item" href="' + esc(a.url) + '"><span class="predictive-item-title">' + esc(a.title) + '</span></a>'
        ).join('') + '</div>'
      );
    }
    if (r.pages && r.pages.length) {
      groups.push(
        '<div class="predictive-group"><h3>Pages</h3>' +
        r.pages.map((p) =>
          '<a class="predictive-item" href="' + esc(p.url) + '"><span class="predictive-item-title">' + esc(p.title) + '</span></a>'
        ).join('') + '</div>'
      );
    }

    if (groups.length) {
      groups.push(
        '<a class="predictive-all" href="' + (routes.search || '/search') + '?q=' + encodeURIComponent(terms) + '">' +
        esc(strings.viewAllResults || 'Voir tous les résultats') + ' →</a>'
      );
      resultsEl.innerHTML = groups.join('');
    } else {
      resultsEl.innerHTML = '';
    }
  }

  if (searchInput) {
    searchInput.addEventListener('input', () => {
      const terms = searchInput.value.trim();
      clearTimeout(searchTimer);
      if (terms.length < 2) {
        if (resultsEl) resultsEl.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(async () => {
        try {
          if (searchAbort) searchAbort.abort();
          searchAbort = new AbortController();
          const url = '/search/suggest.json?q=' + encodeURIComponent(terms) +
            '&resources[type]=product,article,page&resources[limit]=4&resources[options][unavailable_products]=last';
          const res = await fetch(url, { signal: searchAbort.signal });
          renderPredictive(await res.json(), terms);
        } catch (e) { /* requête annulée ou hors ligne */ }
      }, 250);
    });
  }

  /* ═══════════ Facettes (filtres + tri) ═══════════ */

  const facetsForm = document.getElementById('facets-form');
  if (facetsForm) {
    const toggle = facetsForm.querySelector('[data-facets-toggle]');
    const panel = document.getElementById('facets-panel');
    if (toggle && panel) {
      toggle.addEventListener('click', () => {
        const open = panel.hidden;
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      /* Panneau ouvert si des filtres sont actifs */
      if (facetsForm.querySelector('input:checked, input[type="number"][value]:not([value=""])')) {
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }
    }

    function applyFacets() {
      const params = new URLSearchParams();
      facetsForm.querySelectorAll('input[type="checkbox"]:checked').forEach((cb) => {
        params.append(cb.name, cb.value);
      });
      facetsForm.querySelectorAll('input[type="number"]').forEach((inp) => {
        if (inp.value !== '') params.set(inp.name, inp.value);
      });
      const sort = facetsForm.querySelector('[data-facets-sort]');
      if (sort && sort.value) params.set('sort_by', sort.value);
      window.location.href = window.location.pathname + '?' + params.toString();
    }

    facetsForm.addEventListener('submit', (e) => {
      e.preventDefault();
      applyFacets();
    });
    const sortSelect = facetsForm.querySelector('[data-facets-sort]');
    sortSelect && sortSelect.addEventListener('change', applyFacets);
  }

  /* ═══════════ Récemment consultés ═══════════ */

  const RV_KEY = 'remood:recently-viewed';

  function readRecent() {
    try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; }
  }

  /* Enregistrement sur les pages produit */
  if (document.body.classList.contains('template-product')) {
    const match = window.location.pathname.match(/\/products\/([a-z0-9-]+)/i);
    if (match) {
      const handle = match[1];
      const list = readRecent().filter((h) => h !== handle);
      list.unshift(handle);
      try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) { /* stockage plein */ }
    }
  }

  /* Rendu de la section */
  document.querySelectorAll('[data-recently-viewed]').forEach(async (section) => {
    const grid = section.querySelector('[data-recently-viewed-grid]');
    const limit = parseInt(section.dataset.limit, 10) || 4;
    const current = section.dataset.currentHandle;
    const handles = readRecent().filter((h) => h !== current).slice(0, limit);
    if (!handles.length || !grid) return;

    const products = (await Promise.all(
      handles.map((h) => fetch('/products/' + h + '.js').then((r) => (r.ok ? r.json() : null)).catch(() => null))
    )).filter(Boolean);

    if (!products.length) return;
    grid.innerHTML = products.map((p) => {
      const img = p.featured_image
        ? '<img src="' + esc(p.featured_image) + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600" alt="" loading="lazy" width="600" height="600">'
        : '<div class="img-placeholder" style="position:absolute;inset:0;"></div>';
      const compare = p.compare_at_price && p.compare_at_price > p.price
        ? '<s class="rv-compare">' + formatMoney(p.compare_at_price) + '</s>' : '';
      return (
        '<a class="rv-card" href="' + esc(p.url) + '">' +
        '<div class="rv-img">' + img + '</div>' +
        '<h3 class="rv-name">' + esc(p.title) + '</h3>' +
        '<p class="rv-price">' + compare + '<span>' + formatMoney(p.price) + '</span></p></a>'
      );
    }).join('');
    section.hidden = false;
  });

  /* ═══════════ Recommandations produit (API Shopify) ═══════════ */

  document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
    const url = section.dataset.url;
    if (!url || section.querySelector('.prod-related-grid-4')) return; /* déjà rendu côté serveur */
    try {
      section.classList.add('is-loading');
      const res = await fetch(url);
      const html = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const fresh = tmp.querySelector('[data-product-recommendations]');
      if (fresh && fresh.innerHTML.trim()) section.innerHTML = fresh.innerHTML;
    } catch (e) { /* silencieux */ } finally {
      section.classList.remove('is-loading');
    }
  });

  /* ═══════════ Bannière cookies ═══════════ */

  const cookieBanner = document.getElementById('cookie-banner');
  const CONSENT_KEY = 'remood:cookie-consent';
  if (cookieBanner) {
    let stored = null;
    try { stored = localStorage.getItem(CONSENT_KEY); } catch (e) { /* stockage indisponible */ }
    if (!stored) cookieBanner.hidden = false;

    cookieBanner.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-cookie-action]');
      if (!btn) return;
      const accepted = btn.dataset.cookieAction === 'accept';
      try { localStorage.setItem(CONSENT_KEY, accepted ? 'accepted' : 'declined'); } catch (err) { /* — */ }
      cookieBanner.hidden = true;

      /* API Customer Privacy de Shopify si disponible */
      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function (error) {
            if (error || !window.Shopify.customerPrivacy) return;
            window.Shopify.customerPrivacy.setTrackingConsent(accepted, function () {});
          }
        );
      }
    });
  }

  /* ═══════════ Partage — copier le lien ═══════════ */

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.copy-link-btn');
    if (!btn) return;
    try {
      await navigator.clipboard.writeText(btn.dataset.shareUrl || window.location.href);
      btn.classList.add('copied');
      setTimeout(() => btn.classList.remove('copied'), 1600);
    } catch (err) { /* clipboard indisponible */ }
  });

  /* ═══════════ Sélecteur pays/langue (popover desktop) ═══════════ */

  const locToggle = document.querySelector('.loc-toggle');
  const locPopover = document.getElementById('loc-popover');
  if (locToggle && locPopover) {
    locToggle.addEventListener('click', () => {
      const open = locPopover.hidden;
      locPopover.hidden = !open;
      locToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.loc-toggle') && !e.target.closest('#loc-popover')) {
        locPopover.hidden = true;
        locToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ═══════════ Compte — login/recover, adresses ═══════════ */

  const loginForm = document.querySelector('[data-login-form]');
  const recoverForm = document.querySelector('[data-recover-form]');
  if (loginForm && recoverForm) {
    function showRecover(show) {
      loginForm.hidden = show;
      recoverForm.hidden = !show;
    }
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-show-recover]')) { e.preventDefault(); showRecover(true); }
      if (e.target.closest('[data-show-login]')) { e.preventDefault(); showRecover(false); }
    });
    if (window.location.hash === '#recover') showRecover(true);
  }

  /* Adresses : affichage des formulaires + confirmation de suppression */
  document.addEventListener('click', (e) => {
    const toggleBtn = e.target.closest('[data-address-toggle]');
    if (toggleBtn) {
      const form = document.getElementById('address-form-' + toggleBtn.dataset.addressToggle);
      if (form) {
        form.hidden = !form.hidden;
        toggleBtn.setAttribute('aria-expanded', form.hidden ? 'false' : 'true');
      }
    }
    const delBtn = e.target.closest('[data-confirm]');
    if (delBtn && !window.confirm(delBtn.dataset.confirm)) {
      e.preventDefault();
    }
  });

  /* Pays / région (shopify_common.js) */
  if (document.querySelector('[data-address-country-select]')) {
    const initSelectors = () => {
      if (!window.Shopify || !window.Shopify.CountryProvinceSelector) return false;
      document.querySelectorAll('[data-address-country-select]').forEach((select) => {
        const suffix = select.dataset.formId;
        new window.Shopify.CountryProvinceSelector(
          'addr-country-' + suffix,
          'addr-province-' + suffix,
          { hideElement: 'addr-province-wrap-' + suffix }
        );
      });
      return true;
    };
    if (!initSelectors()) window.addEventListener('load', initSelectors);
  }

})();
